import { keyMirror } from 'ramda-extension';

export default keyMirror({
  NEW_INPUT_CHOICE: null,
  IMAGES_SELECT_MODAL: null,
});
